/***************************
Word Reading Difficulty Rule
****************************/
//TODO: reduce code duplication with WordDifficultyRule
// note: until todo is complete consider whether changes are required in tandem between these two files
import Rule from '../Rule';
import {
  ruleInputTypes,
  ruleTypes,
  masteryConditionEnums,
  masteryConditionValues,
} from '../../../constants';
import { LOG_DECISION_CONTEXT } from '../../../config';

const AOA_WRITTEN_MODIFIER = 1.2;

export default class WordDifficultyRule extends Rule {
  constructor(masteryCondition) {
    super([ruleInputTypes.word_AREA_AOA, ruleInputTypes.word_AREA_discrim,ruleInputTypes.studentAREA]);
    this.ruleType = ruleTypes.DIFFICULTY;
    this.masteryCondition = masteryCondition;
  }

  run(state) {
    // Get the params that we need to calculate probability of mastery
    let word_AREA_AOA = state.word_AREA_AOA + AOA_WRITTEN_MODIFIER;
    let word_AREA_discrim = state.word_AREA_discrim;
    let studentAREA = state.studentAREA;

    // If we're missing any inputTypes, return false
    let ruleParams = [word_AREA_AOA, word_AREA_discrim, studentAREA];
    const hasAllInputs = Object.values(ruleParams).every(input => (input !== null));
    if(!hasAllInputs) {
      console.log('Error: runRule called without all necessary inputs. This shouldn\'t ever occur: ', [ruleParams,this.inputTypes]);
      return false;
    }

    // Calculate the logistic probability of mastery
    let probabilityOfMastery = 1 / (1 + Math.pow(Math.E,
      (-word_AREA_discrim * (studentAREA - word_AREA_AOA))
    ));

    let meetsMasteryCondition = false;
    switch(this.masteryCondition[0]) {
      case masteryConditionEnums.ALMOST_CERTAINLY_MASTERED:
        if(probabilityOfMastery > masteryConditionValues.ALMOST_CERTAINLY_MASTERED) {
          meetsMasteryCondition = true;
        }
      break;
      case masteryConditionEnums.LIKELY_MASTERED:
        if(probabilityOfMastery > masteryConditionValues.LIKELY_MASTERED) {
          meetsMasteryCondition = true;
        }
      break;
      case masteryConditionEnums.MAYBE_MASTERED:
        if(probabilityOfMastery > masteryConditionValues.MAYBE_MASTERED) {
          meetsMasteryCondition = true;
        }
      break;
      case masteryConditionEnums.PROBABLY_MASTERED:
        if(probabilityOfMastery > masteryConditionValues.PROBABLY_MASTERED) {
          meetsMasteryCondition = true;
        }
      break;
      case masteryConditionEnums.APPROPRIATELY_CHALLENGING:
        if(probabilityOfMastery > masteryConditionValues.APPROPRIATELY_CHALLENGING[0]) {
          if(probabilityOfMastery < masteryConditionValues.APPROPRIATELY_CHALLENGING[1]) {
            meetsMasteryCondition = true;
          }
        }
      break;
      case masteryConditionEnums.VERY_CHALLENGING:
        if(probabilityOfMastery < masteryConditionValues.VERY_CHALLENGING) {
          meetsMasteryCondition = true;
        }
      break;
      case masteryConditionEnums.SUPER_CHALLENGING:
        if(probabilityOfMastery < masteryConditionValues.SUPER_CHALLENGING) {
          meetsMasteryCondition = true;
        }
      break;
    }
    // invert decision based on user-specified bool
    if(!this.masteryCondition[1]) {
      meetsMasteryCondition = !meetsMasteryCondition;
    }


    let decisionContext;
    if(LOG_DECISION_CONTEXT) {
      decisionContext = {[(this.ruleType + '_' + this.masteryCondition + '_' + meetsMasteryCondition)]: {
        word_AREA_AOA,
        word_AREA_discrim,
        studentAREA,
      }};
    }
    return {
      stateMeetsRuleCondition: meetsMasteryCondition,
      decisionContext,
    }
  }
}